import { render, staticRenderFns } from "./PosMainMenu.vue?vue&type=template&id=5f974939&"
import script from "./PosMainMenu.vue?vue&type=script&lang=js&"
export * from "./PosMainMenu.vue?vue&type=script&lang=js&"
import style0 from "./PosMainMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports